import {
	Component,
	ViewEncapsulation,
	forwardRef,
	ChangeDetectorRef,
	Input,
	TemplateRef,
	OnInit,
} from '@angular/core';
import { ENTER, LEFT_ARROW, RIGHT_ARROW, SPACE } from '@angular/cdk/keycodes';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isEmptyString, isNull } from '../../util/check';

/**
 * This component is used to create Switch button
 * To use this component import FnSwitchModule in Module.
 */
@Component({
	selector: 'fn-switch',
	templateUrl: 'fn-switch.component.html',
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FnSwitchComponent),
			multi: true,
		},
	],
})
export class FnSwitchComponent implements ControlValueAccessor, OnInit {
	/**
	 * Creates an instance of fn switch component.
	 * @param ChangeDetectorRef object
	 */
	constructor(private cdr: ChangeDetectorRef) {}

	/**
	 *  input member variable of boolean type
	 *  used to show Whether the button is checked if true.
	 */
	@Input() checked = false;
	/**
	 * Input member variable of string type
	 * used to create the siwtch button of given size.
	 */
	@Input() fnSize = '';
	/**
	 * Input member variable of string type
	 * used to create the siwtch button of given style.
	 */
	@Input() fnSwitchClass = '';
	
	/**
	 * Input member variable
	 * used to disable the toogle button if true.
	 */
	
	@Input() isDisabled = false;
	/**
	 * Input  member variable
	 * used to show user custom Template  content when toogle butten is checked
	 */
	@Input() checkedTemplate: TemplateRef<void>;
	/**
	 * Input  member variable
	 * used to show custom user Template content when toogle butten is not checked
	 */
	@Input() unCheckedTemplate: TemplateRef<void>;
	/**
	 * Input  member variable to update checked and unchecked color
	 * used to show custom color when switch button is checked or unchecked
	 */
	@Input() colorList: Array<string> = ['#2e8af6' , '#f35151'];

	/**
	 * method to registor function on Touch Event
	 */
	onTouched: () => void;
	/**
	 * method to registor function onChange Event
	 */
	onChange: (value: boolean) => void = () => null;
	ngOnInit(): void {
		if((isNull(this.fnSwitchClass) || isEmptyString(this.fnSwitchClass) && isNull(this.checkedTemplate) && isNull(this.unCheckedTemplate)) ){
		  this.fnSwitchClass = 'fn-switch-custom';
		}
	  }
	/**
	 * bind Event for Toogle button click
	 * @param e
	 */
	clickEvent(e: MouseEvent): void {
		e.preventDefault();
		if (!this.isDisabled) {
			this.updateValue(!this.checked);
		}
	}

	/**
	 * Method to update Value of toogle button
	 * and call onChange Method
	 * @param value of boolen type to set checked Field
	 */
	updateValue(value: boolean): void {
		if (this.checked !== value) {
			this.checked = value;
			this.onChange(this.checked);
		}
	}

	/**
	 * bind event when Key Down event is fire to update value
	 * @param e
	 */
	onKeyDown(e: KeyboardEvent): void {
		if (!this.isDisabled) {
			// tslint:disable-next-line: deprecation
			const keyCode = e.keyCode;
			if (keyCode === LEFT_ARROW) {
				this.updateValue(false);
				e.preventDefault();
			} else if (keyCode === RIGHT_ARROW) {
				this.updateValue(true);
				e.preventDefault();
			} else if (keyCode === SPACE || keyCode === ENTER) {
				this.updateValue(!this.checked);
				e.preventDefault();
			}
		}
	}

	/**
	 * Implementing ControlValueAccessor method to Write a value to the element
	 * @param value the new value for the element
	 */
	writeValue(value: boolean): void {
		this.checked = value;
		this.cdr.markForCheck();
	}

	/**
	 *  Implementing ControlValueAccessor method to Store the change function
	 * @param fn
	 */
	registerOnChange(fn: (_: boolean) => void): void {
		this.onChange = fn;
	}
	/**
	 *  Implementing ControlValueAccessor method to Registers a callback
	 *  function is called by the forms API on initialization to update the form model on blur.
	 * @param fn
	 */
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	/**
	 * Implementing ControlValueAccessor method and called by the forms API when the control status changes to
	 * or from 'DISABLED
	 * @param isDisabled
	 */
	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
		this.cdr.markForCheck();
	}
}
